<template>
  <div class="moreBind">
    <el-card>
      <el-tabs class="header" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="方式一" name="1"></el-tab-pane>
        <el-tab-pane label="方式二" name="2"></el-tab-pane>
      </el-tabs>
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        v-if="activeName==2"
        label-suffix=":"
        class="demo-ruleForm"
      >
        <el-form-item class="input_right" label="姓名" prop="name">
          <el-input placeholder="姓名" v-model="form.name" type="text" />
        </el-form-item>
        <el-form-item class="input_right" label="小区" prop="three">
          <el-input placeholder="小区" v-model.trim="form.three" type="text" />
        </el-form-item>
        <div style="margin-bottom: 6px;">
          门牌号:
          <p class="redText">例如:楼号【1】或单元号【1】或房间号【101】</p>
        </div>
        <el-form-item class="input_right"  prop="mp">
          <el-input placeholder="门牌号" v-model="form.mp" type="text" />
        </el-form-item>

        <el-form-item class="input_right" label="选择分组" >
          <el-select placeholder="选择分组" v-model="fz" style="width: 100%;">
            <el-option label="我家" value="我家"></el-option>
            <el-option label="父母" value="父母"></el-option>
            <el-option label="朋友" value="朋友"></el-option>
            <el-option label="房东" value="房东"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form
        :model="formData"
        :rules="rules"
        ref="ruleForm"
        v-if="activeName==1"
        label-suffix=":"
        class="demo-ruleForm"
      >
        <el-form-item class="input_right" label="小区" prop="three">
          <el-select
            v-model="formData.three"
            filterable
            remote
            ref='select'
            :remote-method="remoteMethod"
            @focus="closeReadOnly"
            @hook:mounted="closeReadOnly"
            @visible-change="closeReadOnly"
            style="width: 100%;"
            placeholder="请输入关键词"
            :loading="loading">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <button @click="searchUser" style="width: 100%;" class="btn_bind">
        查 询
      </button>
    </el-card>

  </div>
</template>

<script>
  import {findLikeThree, getBindYh} from "@/api";

  export default {
    data() {
      return {
        rules: {
          name: [
            {
              required: true, message: '请输入姓名'
            }
          ],
          three: [
            { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
          ],
          mp: [
            {
              required: true, message: '请输入门牌号'
            },
            { pattern: /^[0-9]+$/, message: '只允许输入数字' }
          ],
        },
        form: {},
        fz: '我家',
        activeName: '1',
        formData: {},
        loading: false,
        options: []
      }
    },
    mounted() {

    },
    methods: {
      handleClick() {

      },
      closeReadOnly(val) {
        this.$nextTick(() => {
          if (!val) {
            const input = this.$refs.select.$el.querySelector('.el-input__inner')
            const timer = setTimeout(() => {
              input.removeAttribute('readonly')
              clearTimeout(timer)
            }, 200)
          }
        })
      },
      remoteMethod(query) {
        console.log(query)
        const str = query.replace(/\s+/g,"")
        if (str.length) {
          this.loading = true;
          findLikeThree({companyCode: sessionStorage.getItem('companyCode'), queryStr: str}).then(res=>{
            this.loading = false;
            this.options = [];
            res.data.map(v=>{
              this.options.push({label: v,value: v})
            })
          }).finally(()=>{
            this.loading = false;
          })
        } else {
          this.options = [];
        }
      },
      searchUser() {
        if(this.activeName==2) {
          this.$refs.ruleForm.validate((valid) => {
            if(valid) {
              let params = {
                companyCode: sessionStorage.getItem('companyCode'),
                ...this.form
              }
              getBindYh(params).then(res=>{
                if(res.data.length) {
                  this.$router.push({
                    path: '/bindList',
                    query: {
                      fz: this.fz,
                      params: JSON.stringify(params)
                    }
                  })
                } else {
                  this.$toast('未搜索到用户，请重新输入条件')
                }
              })
            }
          })
        } else {

          if(!this.formData.three) {
            this.$toast('请输入关键字选择小区')
            return
          }
          this.$router.push({
            path: '/bindUserTj',
            query: {
              three: this.formData.three
            }
          })
        }
      }
    }
  }
</script>

<style>
  .moreBind{
    height: 90%;
  }
  .redText{
    color: red;
    font-size: 10px;
  }
  .moreBind .el-tabs__nav{
    width: 100% !important;
  }
  .moreBind .el-tabs__active-bar{
    width: 50%!important;
  }
  .moreBind .el-tabs__item{
    width: 50% !important;
    text-align: center;
  }



</style>



// WEBPACK FOOTER //
// src/view/yhBind/moreBind.vue